import axios, { AxiosResponse } from "axios";
import { ApplicationState } from "core/app";
import * as queryString from "querystring";
import { Response, ApiGet, ApiPost } from "./model";

let cancelToken = axios.CancelToken.source();

function FormattedErrorMessage<TResponse>(error: any) {

    const errorMessage: string = axios.isCancel(error) ? "The request was cancelled."
        : error.message === "Request failed with status code 500" ? error.response?.data?.message ?? "There was an internal error at JAO, please try again."
            : error.message === "Network Error" ? "JAO is deploying a new version of PuTo or your internet connection is lost, please try again."
                : error.message;
    //Automatically called: logError(message.applicationState.applicationRoot, error.response.status, error.response.data);
    return {
        ok: false,
        error: errorMessage,
        errorDetail: error.response?.data?.message ?? "",
        data: {} as TResponse,
    };
}
export const apiCancel = () => {
    cancelToken && cancelToken.cancel('Operation canceled due to new request.');
    cancelToken = axios.CancelToken.source();
}

export const apiDownload = <TResponse>(message: ApiGet) => async () : Promise<string> => {
    try {
        cancelToken && cancelToken.cancel('Operation canceled due to new request.');
        cancelToken = axios.CancelToken.source();
        const headers ={ "Authorization": "Bearer " + message.applicationState.userToken };
        const url = message.route + ((message.query) ? "?" + queryString.stringify(message.query as { [name: string]: any }) : "");
        const response = await axios.get(url, {headers, cancelToken: cancelToken.token });
        
        if (response === undefined) alert("Error 2234");
        if (response.data === undefined) alert("Error 2235");

        let download = response?.data?.downloadUrl;
        let showDownloadProgress = false;
        if (showDownloadProgress) {
            let responseB = await axios({
                url: response?.data?.downloadUrl,
                onDownloadProgress: (ev) => { console.log(ev); },
                method: 'GET',
                responseType: 'blob', // important
            });
            if (responseB === undefined) alert("Error 2236");
            download = window.URL.createObjectURL(new Blob([responseB.data]));
        } 

        const link = document.createElement("a");
        link.href = download;
        link.setAttribute("download", response?.data?.fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        //TODO Detect that the download has been initiated  
        return "";
    } catch (e) {
        return FormattedErrorMessage<TResponse>(e).error;
    }
};
export const apiTryGet = (message: ApiGet) => async (): Promise<AxiosResponse<any>> => {
    try {
        cancelToken && cancelToken.cancel('Operation canceled due to new request.');
        cancelToken = axios.CancelToken.source();
        const headers ={ "Authorization": "Bearer " + message.applicationState.userToken };
        const url = message.route + ((message.query) ? "?" + queryString.stringify(message.query as { [name: string]: any }) : "");
        return await axios.get(url, {headers, cancelToken: cancelToken.token });
    } catch (e) {
        let error = (e as any);
        if (axios.isCancel(error)) return { data: { Canceled:"This request was canceled"}, status: 0, headers: {}, statusText: "Canceled", config: {} };
        return error.response;
    }
};
export const apiTryPost = (message: ApiPost) => async (): Promise<AxiosResponse<any>> => {
       try {
        cancelToken && cancelToken.cancel('Operation canceled due to new request.');
        cancelToken = axios.CancelToken.source();
        const headers ={ "Authorization": "Bearer " + message.applicationState.userToken };
        return await axios.post(message.route, message.query, {headers, cancelToken: cancelToken.token });
    } catch (e) {
        let error = (e as any);
        if (axios.isCancel(error)) return { data: { Canceled:"This request was canceled"}, status: 0, headers: {}, statusText: "Canceled", config: {} };
        return error.response;
    }
};


export const apiGet = <TResponse>(message: ApiGet) => async (): Promise<Response<TResponse>> => {

    try {
        //cancelToken && cancelToken.cancel('Operation canceled due to new request.');
        cancelToken = axios.CancelToken.source();
        const headers ={ "Authorization": "Bearer " + message.applicationState.userToken };
        const url = message.route + ((message.query) ? "?" + queryString.stringify(message.query as { [name: string]: any }) : "");
        const response = await axios.get<TResponse>(url, {headers, cancelToken: cancelToken.token });
        return {
            ok: response.status === 200,
            data: response.data,
        };
    } catch (e) {
        return FormattedErrorMessage<TResponse>(e);
    } finally {

    }
};

export const apiPost = <TResponse>(message: ApiPost) => async (): Promise<any> => {
    try {
        //cancelToken && cancelToken.cancel('Operation canceled due to new request.');
        cancelToken = axios.CancelToken.source();
        const headers ={ "Authorization": "Bearer " + message.applicationState.userToken };
        const response = await axios.post(message.route, message.query, { headers, cancelToken: cancelToken.token });
        return {
            ok: response.status === 200,
            data: response.data,
        };
    } catch (e) {
        return FormattedErrorMessage<TResponse>(e);
    } finally {

    }
};

export const logError = (applicationRoot: string, code: string, error: string) => {
    const url = applicationRoot + "reportClientError";

    try {
        axios.post(url, { reference: code, message: error });
    }catch (e) {
        let error = (e as any);
        // too bad we could not log error, but not necesairy to notify user about this
    }
};


export default {
    apiCancel:apiCancel,
    apiPost: apiPost,
    apiGet: apiGet,
    logError: logError,
    apiDownload: apiDownload,
    apiTryGet: apiTryGet,
    apiTryPost: apiTryPost,
};
